import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import { WidgetService } from '../../../services/widget/widget.service';
import { UserService } from "../../../services/user/user.service";

@Component({
  selector: 'count-map',
  templateUrl: './count-map.component.html',
  styleUrls: ['./count-map.component.scss']
})
export class CountMapComponent implements OnInit {
  @Input('graphData') graphData: any;
  @Input('requestBody') requestBody: any;
  @Input('predictive') predictive: any;
  countConfig: any = {};
  dataCount = { count: "0", kpiType: "", dayOfWeek:"", dateOfMonth:""};
  predictedCount = '0';
  compareData = false;
  variance = '(0%)';
  originalCountV = 0;
  increseInPe: number = 0;
  trendC = { isTrend: false, trendColor: "" };
  suffixL = "";
  prefixL = "";
  isDayOfWeek :boolean = false;
  isDayOfMonth :boolean = false;
  constructor(private commonService: CommonService, private widgetService: WidgetService, public userService: UserService) { }
  ngOnChanges() {
    let count: any = 0;
    if (this.graphData.dataFilter[0].data.length > 0) {
      count = this.graphData.dataFilter[0].data[0].value;
      this.originalCountV = count;
    }

    if (this.countConfig.formatNumber == "-1") {
      this.dataCount.count = this.commonService.shortNumberFormat(count);
    } else {
      let n = !this.countConfig.formatNumber ? 0 : this.countConfig.formatNumber;
      count = !count ? 0.00 : parseFloat(count);
      this.dataCount.count = count.toFixed(n);
    }

  }

  ngOnInit() {
    let count = 0;
    this.compareData = this.graphData.udf.compareConfig && (Object.keys(this.graphData.udf.compareConfig).length > 0 && this.graphData.dataFilter.length > 1);
    if(this.compareData && this.graphData.udf.compareConfig['differenceTiming'] && (this.graphData.udf.compareConfig['differenceTiming']['day'] || this.graphData.udf.compareConfig['differenceTiming']['date'])){
      this.isDayOfMonth = this.graphData.udf.compareConfig['differenceTiming']['date'] ? this.graphData.udf.compareConfig['differenceTiming']['date'] : false;
      this.isDayOfWeek = this.graphData.udf.compareConfig['differenceTiming']['day']?  this.graphData.udf.compareConfig['differenceTiming']['day'] : false;
      this.dataCount.dayOfWeek = this.graphData.dataFilter[0].dayOfWeek ? this.graphData.dataFilter[0].dayOfWeek : "";
      this.dataCount.dateOfMonth = this.graphData.dataFilter[0].dateOfMonth ?  this.graphData.dataFilter[0].dateOfMonth : "";
    }
    if (this.graphData.dataFilter[0].data.length > 0) {
      count = this.graphData.dataFilter[0].data[0].value;
      this.originalCountV = count;
    }

    if (this.graphData.udf && this.graphData.udf.countConfig) {
      this.countConfig = this.graphData.udf.countConfig;
    } else {
      this.countConfig = {
        formatNumber: "-1",
        boxColor: "",
        valueColor: "",
        labelColor: "",
        borderThickness: 0,
        borderColor: "",
        isTrendE: false,
        trendColor: ""
      }
    }

    // suffixL and prefixL
    if (this.graphData.udf && this.graphData.udf.kpiNumberConfig && this.graphData.udf.kpiNumberConfig.length > 0) {
      this.suffixL = this.graphData.udf.kpiNumberConfig[0].suffixLabel;
      this.prefixL = this.graphData.udf.kpiNumberConfig[0].prefixLabel;
    }

    if (!this.countConfig.formatNumber && this.countConfig.formatNumber != 0) {
      this.countConfig.formatNumber = "-1";
    }
    if (!count) {
      count = 0;
    }
    // if (this.graphData.dataFilter.length > 1 && this.graphData.dataFilter[1].data.length>0)
    //   this.variance = this.graphData.dataFilter[1].data[0].value + '%';    
    if (this.graphData.dataFilter.length > 1 && this.graphData.dataFilter[1].data.length > 0) {
      this.predictedCount = this.graphData.dataFilter[1].data[0].value;
      if (count > 0) {
        var v = parseInt(((parseInt(this.predictedCount) * 100) / count).toFixed(2));
        this.variance = '(' + v + '%)';
      }
      else {
        this.variance = '(' + this.predictedCount + '%)';
      }
    }
    // this.dataCount = { count: this.commonService.shortNumberFormat(count), kpiType: this.graphData.dataFilter[0].label };
    this.dataCount.dayOfWeek = this.dataCount.dayOfWeek;
    this.dataCount.dateOfMonth = this.dataCount.dateOfMonth;
    if (this.countConfig.formatNumber == "-1") {
      this.dataCount = { count: this.commonService.shortNumberFormat(count), kpiType: this.graphData.title, dayOfWeek:this.dataCount.dayOfWeek, dateOfMonth:this.dataCount.dateOfMonth };
      if (this.graphData.dataFilter[0].isThousandSeperator)
        this.dataCount.count = this.commonService.formatNumberString(this.dataCount.count, true);
      else
        this.dataCount.count = this.commonService.formatNumberString(this.dataCount.count, false);
      if (this.predictive && this.graphData.dataFilter.length > 1) {
        this.predictedCount = this.commonService.shortNumberFormat(parseInt(this.predictedCount))
        if (this.graphData.dataFilter[0].isThousandSeperator)
          this.predictedCount = this.commonService.formatNumberString(this.predictedCount, true);
        else
          this.predictedCount = this.commonService.formatNumberString(this.predictedCount, false);
      }
    } else {
      this.dataCount = { count: count.toFixed(this.countConfig.formatNumber), kpiType: this.graphData.title, dayOfWeek:this.dataCount.dayOfWeek, dateOfMonth:this.dataCount.dateOfMonth };
      if (this.graphData.dataFilter[0].isThousandSeperator)
        this.dataCount.count = this.commonService.formatNumberString(this.dataCount.count, true);
      else
        this.dataCount.count = this.commonService.formatNumberString(this.dataCount.count, false);
      if (this.predictive && this.graphData.dataFilter.length > 1) {
        this.predictedCount = parseInt(this.predictedCount).toFixed(this.countConfig.formatNumber);
        if (this.graphData.dataFilter[0].isThousandSeperator)
          this.predictedCount = this.commonService.formatNumberString(this.predictedCount, true);
        else
          this.predictedCount = this.commonService.formatNumberString(this.predictedCount, false);
      }
    }
    if (this.predictive && (this.predictedCount === '0' || parseInt(this.predictedCount) === 0)) {
      this.predictedCount = 'No Sufficient Data';
      this.variance = '';
    }
    // let toDate=new Date(this.graphData.to)
    // console.log(this.graphData)
    if (new Date(this.graphData.to).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
      this.variance = '';
    }
    if (this.graphData.dataFilter.length > 0) {
      this.graphData.dataFilter.forEach((el, i) => {
        if (i > 0 && el.data && el.data.length > 0) {
          el.data[0].dValue = (this.countConfig.formatNumber == "-1" ? this.commonService.shortNumberFormat(Number(el.data[0].value)) : parseFloat(el.data[0].value).toFixed(this.countConfig.formatNumber));
          if (el.isThousandSeperator)
            el.data[0].dValue = this.commonService.formatNumberString(el.data[0].dValue, true);
          else
            el.data[0].dValue = this.commonService.formatNumberString(el.data[0].dValue, false);
          if (el.data[0].variance) {
            if (el.isThousandSeperator)
              el.data[0].dVariance = this.commonService.formatNumberString(el.data[0].variance, true);
            else
              el.data[0].dVariance = this.commonService.formatNumberString(el.data[0].variance, false);
          }
          if (el.data[0].differance) {
            el.data[0].dDifferance = (this.countConfig.formatNumber == "-1" ? this.commonService.shortNumberFormat(Number(el.data[0].differance)) : parseFloat(el.data[0].differance).toFixed(this.countConfig.formatNumber));
            if (el.isThousandSeperator)
              el.data[0].dDifferance = this.commonService.formatNumberString(el.data[0].dDifferance, true);
            else
              el.data[0].dDifferance = this.commonService.formatNumberString(el.data[0].dDifferance, false);
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/count-map/count-map.component.ts